import Identity from "./identity"

export default class Buchung extends Identity {
  buchungType: string
}
